import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  loadUser,
  loadNotifications
  // saveNewNotifications
} from '../../../actions';
import { createOfficeIntegration } from '../../../utils/officeIntegration';

// import useNotifications from '../../../hooks/useNotifications';
// import NewNotifications from '../Notifications/NewNotifications';

const Auth = ({
  children,
  logged,
  history,
  location,
  loadUserHandler,
  loadNotificationsHandler
  // notifications,
}) => {
  const [notificationsLoaded, setNotificationsLoaded] = useState(false);
  const [pullingInterval, setPullingInterval] = useState(null);
  // const [filterNotifications, handleNotifications] = useNotifications(null);

  useEffect(() => {
    loadUserHandler(history, location.pathname);
    loadNotificationsHandler().then(refresh => {
      if (!notificationsLoaded) {
        setNotificationsLoaded(true);
      }
      clearInterval(pullingInterval);

      setPullingInterval(
        setInterval(() => {
          loadNotificationsHandler();
        }, refresh)
      );
    });

    createOfficeIntegration();
    return () => {
      if (pullingInterval) {
        clearInterval(pullingInterval);
      }
    };
  }, []);

  // - - - - - - - - - - - - - - - - - - - - -
  // Notificaciones Emergentes (Desactivado)

  // useEffect(() => {
  // if (notifications && notifications.length > 0) {
  // handleNotifications(notifications);
  // }
  // }, [notifications]);

  // const newNotifications = () =>
  // filterNotifications &&
  // filterNotifications.length > 0 && (
  // <NewNotifications filterNotifications={filterNotifications} />
  // );
  // - - - - - - - - - - - - - - - - - - - - -

  return <div>{logged && notificationsLoaded ? <>{children}</> : false}</div>;
};

const mapStateToProps = ({ user, notifications }) => ({
  logged: user.logged,
  notifications: notifications.notificationsList
});

const mapDispatchToProps = dispatch => ({
  loadUserHandler: (history, path) => loadUser(dispatch, history, path),
  loadNotificationsHandler: () => loadNotifications(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
